import { useParams } from 'react-router-dom';
import TenantDetail from '../features/tenants/TenantDetail';

export const TenantDetailPage = () => {
  const { id } = useParams<{ id: string }>();
  return <TenantDetail id={id!} />;
};
